import styled from 'styled-components'

const Separator = styled.div`
  height: 2px;
  background: ${props => props.theme.colors.gallery};
  margin: ${props => (props.doubleGap ? '72px' : '36px')} 0;
`

export default Separator
